import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Button, Input } from "components/bootstrap";
import { Select } from "components/common";
import ServiceAccountKeyFilePicker from "../repository-management/ServiceAccountKeyFilePicker";
const AUTH_OPTIONS = [
  { value: "automatic", labelKey: "gcs_credentials.auth_automatic" },
  { value: "service_account_key", labelKey: "gcs_credentials.auth_service_account_key" }
];
export const validateGcsCredentialsForm = (values) => {
  const errors = {};
  if (values.auth_mode === "service_account_key" && (!values.service_account_key || "delete_value" in values.service_account_key)) {
    errors.service_account_key = i18n.t("gcs_credentials.service_account_key_required", {
      ns: "enterprise_data_tiering"
    });
  }
  return errors;
};
const GcsCredentialsFormFields = ({ keyIsSet, clientEmail = null }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { values, errors, setFieldValue } = useFormikContext();
  const authOptions = AUTH_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
  const [replacingKey, setReplacingKey] = useState(false);
  const [fileName, setFileName] = useState();
  const keyError = errors.service_account_key;
  const showKeyStatus = keyIsSet && !replacingKey;
  const setKey = (key) => setFieldValue("service_account_key", key);
  const startReplacing = () => {
    setKey(void 0);
    setReplacingKey(true);
  };
  const keepCurrentKey = () => {
    setKey({ keep_value: true });
    setFileName(void 0);
    setReplacingKey(false);
  };
  const handleAuthModeChange = (authMode) => {
    if (authMode === values.auth_mode) {
      return;
    }
    if (authMode === "automatic") {
      setKey(void 0);
      setFileName(void 0);
      setReplacingKey(false);
    } else {
      setKey(keyIsSet ? { keep_value: true } : void 0);
      setReplacingKey(false);
    }
    setFieldValue("auth_mode", authMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-auth-mode",
      label: t("gcs_credentials.auth_type"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "credentialsAuthMode",
        name: "auth_mode",
        placeholder: t("gcs_credentials.auth_type_placeholder"),
        "aria-label": t("gcs_credentials.auth_type_aria"),
        options: authOptions,
        onChange: handleAuthModeChange,
        clearable: false,
        value: values.auth_mode
      }
    )
  ), values.auth_mode === "service_account_key" && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-service-account-key",
      label: t("gcs_credentials.service_account_key"),
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: clientEmail ? t("gcs_form.service_account_help", { email: clientEmail }) : t("gcs_credentials.service_account_key_help")
    },
    showKeyStatus ? /* @__PURE__ */ React.createElement("div", null, t("gcs_form.key_set"), " ", /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: startReplacing }, t("gcs_form.replace_key"))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ServiceAccountKeyFilePicker,
      {
        fileName,
        onFileRead: (content, name) => {
          setKey({ set_value: content });
          setFileName(name);
        }
      }
    ), keyIsSet && /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: keepCurrentKey }, t("gcs_form.keep_current_key")))
  ));
};
export default GcsCredentialsFormFields;
